import React from 'react';
import {
  CenterButtonContainer,
  TextBold,
  TextRegular,
} from '../../../styles/GlobalStyledComponents';
import TimeoutImage from '../../../assets/images/Timeout/TimeoutImg.svg';
import Button from '../../../components/Button/Button';
import { colors } from '../../../styles/Colors';
import IframeService from '../../../services/Iframe';
import TokenService from '../../../services/Token';
import { webviewMessage } from '../../../utils/webviewHelper';
import {
  ImgWrapper,
  ModalImgDiv,
  ModalTextWrapper,
  ModalWrapper,
} from '../FinalModalStyledComponents';
import { ViewMode } from '../../../interfaces/Mode';
import { getRedirectionUrl, getUtmParams } from '../../../utils/urlParams';

const Timeout = () => {
  const { red4, white } = colors;

  const viewMode = sessionStorage.getItem('pepper-view-mode');
  const finalParams = getUtmParams(true);

  const goToClientArea = () => {
    if (
      viewMode === ViewMode.APP ||
      viewMode === ViewMode.IFRAME ||
      viewMode === ViewMode.CLIENTES
    ) {
      if (viewMode === ViewMode.APP) {
        webviewMessage({ data: 'timeout' });
        window.parent.postMessage({
          data: 'timeout',
        }, '*');
      } else if (viewMode === ViewMode.CLIENTES) {
        const winRef = window.opener;
        if (winRef) {
          const targetOrigin = document.referrer;
          winRef.postMessage('timeout', targetOrigin);
        }
      } else {
        IframeService.closeIframe('timeout');
      }
      TokenService.clearSession();
    } else {
      TokenService.clearSession();
      window.location.href = getRedirectionUrl(finalParams);
    }
  };

  return (
    <ModalWrapper id="timeout-page">
      <ImgWrapper>
        <ModalImgDiv
          src={TimeoutImage}
          id="timeout-img"
          alt="timeout image"
          title="timeout image"
          width={''}
          height={''}
        />
      </ImgWrapper>
      <ModalTextWrapper id="timeout-title-wrapper">
        <TextBold fontSize={24} align="center" id="timeout-title">
          ¡Ups... Parece que el enlace ha caducado!
        </TextBold>
      </ModalTextWrapper>
      <ModalTextWrapper id="timeout-text-wrapper">
        <TextRegular fontSize={18} id="timeout-text" color="gray6">
          Puedes revisar la información de tu préstamo accediendo al Área
          Cliente.
        </TextRegular>
      </ModalTextWrapper>
      {viewMode !== ViewMode.IFRAME && (
        <CenterButtonContainer id="timeout-back-btn-container">
          <Button
            color={white}
            borderColor={red4}
            backgroundColor={red4}
            minWidth="280px"
            click={() => goToClientArea()}
            id="timeout-back-btn"
          >
            <TextRegular fontSize={18} color={white}>
              Ir al Área Cliente
            </TextRegular>
          </Button>
        </CenterButtonContainer>
      )}
    </ModalWrapper>
  );
};

export default Timeout;
